import { render } from "./DataStandards.vue?vue&type=template&id=f88315f0"
import script from "./DataStandards.js?vue&type=script&lang=js"
export * from "./DataStandards.js?vue&type=script&lang=js"

import "./DataStandards.vue?vue&type=style&index=0&id=f88315f0&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__